<template>
  <v-toolbar light color="primary" style="z-index: 99; position: fixed; top: 0;">
    <v-btn v-show="backLink" icon @click="goBack">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-show="iconVisibility || editModePossible" :disabled="disabledState" icon @click="buttonClicked">
      <v-icon v-if="iconVisibility" class="cart" :class="{'shopping': this.$store.getters.getShoppingState }">shopping_cart</v-icon>
      <v-icon v-if="editModePossible">{{ editMode }}</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex'
  export default {
    name: 'main-header',
    computed: {
      title () {
        switch (this.$route.name) {
          case 'lists': return 'Mijn lijsten'
          case 'list': return this.$store.getters.getCurrentList.name
          case 'addList': return 'Lijst toevoegen'
          case 'categories': return 'Productgroepen'
          case 'category':
            const categories = this.$store.getters.getCategories
            const category = categories.find(category => {
              if (category.id === this.$route.params.id) return category
            })
            return `${category.name} toevoegen`
          case 'addCategory': return 'Productgroep toevoegen'
          case 'addProduct': return 'Product toevoegen'
        }
      },
      backLink () {
        if (this.$route.name !== 'lists') return true
      },
      iconVisibility () {
        if (this.$route.name === 'list') return true
      },
      editModePossible () {
        if (this.$route.name === 'lists' || this.$route.name === 'categories' || this.$route.name === 'category') return true
      },
      editMode () {
        return this.$store.getters.getEditMode ? 'done' : 'mode_edit'
      },
      disabledState () {
        if (!this.getCurrentList()) return
        return this.getCurrentList().items.length === 0 && this.$route.name === 'list'
      }
    },
    methods: {
      ...mapMutations({
        'toggleShoppingMode': 'TOGGLE_SHOPPING_MODE',
        'toggleEditMode': 'TOGGLE_EDIT_MODE'
      }),
      ...mapGetters({
        'getCurrentList': 'getCurrentList'
      }),
      buttonClicked () {
        switch (this.$route.name) {
          case 'lists': return this.toggleEditMode()
          case 'list':
            this.toggleShoppingMode()
            if (!this.$store.state.commonStore.shopping) this.$store.dispatch('setCollectedItemsToSuggestion')
            break
          case 'categories': return this.toggleEditMode()
          case 'category': return this.toggleEditMode()
        }
      },
      goBack () {
        this.$store.commit('SET_NAV_DIRECTION', 'back')
        switch (this.$route.name) {
          case 'list':
            this.$router.push({name: 'lists'})
            this.$store.commit('TOGGLE_SHOPPING_MODE', false)
            this.$store.commit('SET_CURRENT_LIST', null)
            break
          case 'addList': return this.$router.push({name: 'lists'})
          case 'categories': return this.$router.push({name: 'list', params: {id: this.$store.state.listsStore.currentListId}})
          case 'category':
            this.$router.push({name: 'categories'})
            this.$store.commit('SET_CURRENT_CATEGORY', null)
            break
          case 'addCategory': return this.$router.push({name: 'categories'})
          case 'addProduct': return this.$router.push({name: 'category', params: {id: this.$store.getters.getCurrentCategory}})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cart {
    position: relative;

    &::before {
      position: absolute;
      bottom: 0;
      right: -1px;
      content: '';
      border-top: 5px solid transparent;
      border-left: 10px solid #fa6f6f;
      border-bottom: 5px solid transparent;
      transform: scale(1.5);
      border-top-right-radius: 10px;
      border-top-left-radius: 2px;
    }

    &:after {
      position: absolute;
      bottom: 0;
      right: 0;
      content: '';
      border-top: 5px solid transparent;
      border-left: 10px solid #210f0f;
      border-bottom: 5px solid transparent;
      transition: border-color 0.3s cubic-bezier(.25,.8,.5,1) 0.2s;
    }

    &.shopping {
      &:before {
        right: 0;
        border: 0;
        border-radius: 0;
        width: 10px;
        height: 10px;
        background: #fa6f6f;
        transform: scale(1.3);
      }
      &:after {
        border: 0;
        width: 10px;
        height: 10px;
        background-color: #210f0f;
      }
    }
  }

  .btn--disabled > .btn__content > .cart::after {
    border-left-color: rgba(0,0,0,0.38);
  }
</style>



// WEBPACK FOOTER //
// MainHeader.vue?78bd5547